var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7879 10.2247C19.7879 9.56634 19.7296 8.94134 19.6296 8.33301H10.2129V12.0913H15.6046C15.3629 13.3247 14.6546 14.3663 13.6046 15.0747V17.5747H16.8212C18.7046 15.833 19.7879 13.2663 19.7879 10.2247Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2128 19.9999C12.9128 19.9999 15.1712 19.0999 16.8212 17.5749L13.6045 15.0749C12.7045 15.6749 11.5628 16.0415 10.2128 16.0415C7.60451 16.0415 5.39618 14.2832 4.60451 11.9082H1.28784V14.4832C2.92951 17.7499 6.30451 19.9999 10.2128 19.9999Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60456 11.9083C4.39622 11.3083 4.28789 10.6666 4.28789 9.99993C4.28789 9.33327 4.40456 8.6916 4.60456 8.0916V5.5166H1.28789C0.604556 6.8666 0.212891 8.38327 0.212891 9.99993C0.212891 11.6166 0.604556 13.1333 1.28789 14.4833L4.60456 11.9083Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2128 3.95833C11.6878 3.95833 13.0045 4.46667 14.0462 5.45834L16.8962 2.60833C15.1712 0.991668 12.9128 0 10.2128 0C6.30451 0 2.92951 2.25 1.28784 5.51667L4.60451 8.09167C5.39618 5.71667 7.60451 3.95833 10.2128 3.95833Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.6501c49107ef79ee871ff3590c5b964a.svg";
export { ForwardRef as ReactComponent };